import customPage from './validation/custom-page'
import workflow from './components/workflow'
import workspace from './components/workspace'
import team from './components/team'
import organization from './components/organization'
import tags from './components/tags'
import plugins from './components/plugins'
import inputTemplateForm from './components/input-template-form'
import incidents from './components/incidents'
import insights from './components/insights'
import customTable from './components/custom-table'
import analyticsReports from './components/analytics-reports'
import customTableValidation from './validation/custom-table'

export default {
    validation: {
        'custom-page': customPage,
        'custom-table': customTableValidation,
    },
    common: {
        delete: 'Delete',
        preview: 'Preview',
        create: 'Create',
        submit: 'Submit',
        confirm: 'Confirm',
        save: 'Save',
        close: 'Close',
        cancel: 'Cancel',
        oops: 'Ooops...',
        'something-went-wrong': 'Ooops... something went wrong',
        success: 'Success',
        error: 'Error: {error}',
        'generic-error': 'Error',
        id: 'ID',
        language: 'Language',
        'discard-changes': 'You have unsaved changes. Are you sure you want to leave?',
        'select-all': 'Select all',
        'deselect-all': 'Deselect all',
    },
    components: {
        workflow,
        workspace,
        team,
        tags,
        plugins,
        incidents,
        'custom-table': customTable,
        'input-template-form': inputTemplateForm,
        insights,
        'analytics-reports': analyticsReports,
        organization,
    },
    errors: {
        teamMember: {
            alreadyExists: 'Team member with this email already exists',
        },
    },
}
